import { Box, Flex, StyleProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { rem } from '@bonusly/ds-utils';

import { assertIsDateRange } from '../../types';
import { useMonthPickerContext } from '../month-picker-context';

export type MonthRangeHeaderProps = StyleProps;

export const MonthRangeHeader: FC<MonthRangeHeaderProps> = (props) => {
	const { t } = useTranslation('components');
	const { interimValue } = useMonthPickerContext();

	assertIsDateRange(interimValue);

	// If only a start month is selected, display it for both start and end
	const displayMonths = [interimValue[0], interimValue[1] ?? interimValue[0]];

	return (
		<Flex alignItems="center" mb={1} columnGap={2} {...props}>
			{displayMonths.map((month, index) => (
				<Box
					key={index}
					bg="white"
					borderColor="gray.200"
					borderRadius="md"
					borderStyle="solid"
					borderWidth="1px"
					color={month ? 'text.default' : 'text.softest'}
					flexBasis={0}
					flexGrow={1}
					justifyContent="flex-start"
					fontWeight="normal"
					minH={rem(40)}
					px={3}
					py={2}
				>
					{month
						? t('date_picker.month_value_short', {
								date: month,
								interpolation: { escapeValue: false },
							})
						: t('date_picker.date_placeholder')}
				</Box>
			))}
		</Flex>
	);
};
